import CreativesComponent from "../../modules/creatives/creatives";

export default function Creatives() {
    return <CreativesComponent role="organization" />;
}